<template>
  <div>
    <Navigation />
    <div class="wrap">
      <div class="head">
        <div>
          <h1>Notifications Log</h1>
          <p class="lede">Every SMS Paysol has tried to send from your business.</p>
        </div>
        <button class="secondary" @click="load">Refresh</button>
      </div>
      <div class="card kpi-strip">
        <div class="kpi"><div class="kpi-label">Sent (24h)</div><div class="kpi-val ok">{{ counts.sent }}</div></div>
        <div class="kpi warn"><div class="kpi-label">Failed (24h)</div><div class="kpi-val">{{ counts.failed }}</div></div>
        <div class="kpi"><div class="kpi-label">Total logged</div><div class="kpi-val">{{ rows.length }}</div></div>
      </div>
      <div class="card">
        <table v-if="rows.length">
          <thead><tr><th>When</th><th>Channel</th><th>To</th><th>Status</th><th>Body</th><th>Ref / Error</th></tr></thead>
          <tbody>
            <tr v-for="r in rows" :key="r.id">
              <td class="muted small">{{ r.created_at }}</td>
              <td>{{ r.channel }}</td>
              <td>{{ r.recipient }}</td>
              <td><span :class="'n-pill ' + r.status">{{ r.status }}</span></td>
              <td class="body">{{ r.body }}</td>
              <td class="muted small">{{ r.provider_ref || r.error || '—' }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="muted center">No notifications sent yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/paysol-nav/Navigation.vue';
import { paysol, execute } from '@/api';

export default {
  name: 'NotificationsLog',
  components: { Navigation },
  data() { return { rows: [] }; },
  computed: {
    counts() {
      const cutoff = Date.now() - 24 * 60 * 60 * 1000;
      const recent = this.rows.filter(r => new Date(r.created_at).getTime() > cutoff);
      return {
        sent: recent.filter(r => r.status === 'sent').length,
        failed: recent.filter(r => r.status === 'failed').length,
      };
    }
  },
  async mounted() { await this.load(); },
  methods: {
    async load() {
      const { data } = await execute({ function: 'listNotifications', limit: 300 }, paysol);
      if (data.success) this.rows = data.data;
    },
  }
};
</script>

<style scoped>
.wrap { max-width: 1200px; margin: 0 auto; padding: 24px; }
.head { display: flex; justify-content: space-between; align-items: end; margin-bottom: 20px; }
h1 { font-size: 26px; margin: 0 0 4px; color: var(--paysol-text); }
.lede { color: var(--paysol-muted); margin: 0; }
.kpi-strip { display: flex; gap: 12px; padding: 14px; margin-bottom: 12px; }
.kpi { flex: 1; padding: 12px 16px; background: var(--paysol-bg-elev); border-left: 3px solid var(--paysol-teal); border-radius: 6px; }
.kpi.warn { border-left-color: var(--paysol-warning); }
.kpi-label { color: var(--paysol-muted); font-size: 11px; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600; }
.kpi-val { color: var(--paysol-text); font-size: 22px; font-weight: 700; margin-top: 3px; }
.kpi-val.ok { color: var(--paysol-success); }
.muted { color: var(--paysol-muted); }
.small { font-size: 11px; }
.center { text-align: center; padding: 40px 0; }
.body { max-width: 340px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.n-pill { display: inline-block; padding: 3px 8px; border-radius: 3px; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
.n-pill.sent { background: rgba(16,185,129,.15); color: var(--paysol-success); }
.n-pill.failed { background: rgba(239,68,68,.15); color: var(--paysol-danger); }
.n-pill.queued { background: rgba(139,164,196,.15); color: var(--paysol-muted); }
</style>
